import React from "react";
import { Link } from "react-router-dom";
import { MarketingLayout } from "@byscott-io/corebyscott";

export default function LandingPage() {
  return (
    <MarketingLayout>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-b from-indigo-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Analytics for Your <span className="text-indigo-600">Apps</span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Track events, measure metrics, and understand your users.
            A privacy-focused analytics platform built for the IdeasByScott ecosystem.
          </p>
          <div className="flex gap-4 justify-center">
            <Link
              to="/register"
              className="px-8 py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors"
            >
              Get Started Free
            </Link>
            <Link
              to="/pricing"
              className="px-8 py-3 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
            >
              View Pricing
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Everything You Need
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="text-4xl mb-4">⚡</div>
              <h3 className="text-xl font-semibold mb-2">Event Tracking</h3>
              <p className="text-gray-600">
                Track user actions, page views, and feature usage with simple API calls.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="text-4xl mb-4">📈</div>
              <h3 className="text-xl font-semibold mb-2">Time-Series Metrics</h3>
              <p className="text-gray-600">
                Track values over time with built-in temporal queries and aggregation.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="text-4xl mb-4">🔒</div>
              <h3 className="text-xl font-semibold mb-2">Privacy First</h3>
              <p className="text-gray-600">
                Your data stays yours. No third-party tracking or data selling.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SDK Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Easy Integration
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg p-6 shadow">
              <h3 className="text-lg font-semibold mb-4">Ruby</h3>
              <pre className="text-sm bg-gray-100 p-4 rounded overflow-x-auto">
{`gem "metricsbyscott_client"

MetricsByScott.track(
  "page_view",
  path: "/dashboard"
)`}
              </pre>
            </div>
            <div className="bg-white rounded-lg p-6 shadow">
              <h3 className="text-lg font-semibold mb-4">React</h3>
              <pre className="text-sm bg-gray-100 p-4 rounded overflow-x-auto">
{`import { useMetrics }
  from '@byscott-io/
    metricsbyscott-web';

const { track } = useMetrics();
track('button_click');`}
              </pre>
            </div>
            <div className="bg-white rounded-lg p-6 shadow">
              <h3 className="text-lg font-semibold mb-4">React Native</h3>
              <pre className="text-sm bg-gray-100 p-4 rounded overflow-x-auto">
{`import { useMetrics }
  from '@byscott-io/
    metricsbyscott-mobile';

const { track } = useMetrics();
track('screen_view');`}
              </pre>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Ready to Get Started?
          </h2>
          <p className="text-gray-600 mb-8">
            Start tracking your app analytics in minutes.
          </p>
          <Link
            to="/register"
            className="px-8 py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors"
          >
            Create Free Account
          </Link>
        </div>
      </section>
    </MarketingLayout>
  );
}
